export interface PTZProps {
  cameraId: string;
}

export enum CameraSpeedGear {
  NEUTRAL = 0,
  LOWEST = 5,
  MIDDLE = 25,
  HIGHEST = 127,
}

export type Zoom = {
  isZoomingIn: boolean;
  isZoomingOut: boolean;
};
